import Vue from 'vue'
import Vuex from 'vuex'
import action from './action'
import Cookies from 'js-cookie'
Vue.use(Vuex)

const state = {
  texture: {
    1: '兔毫',
    2: '鹧鸪斑',
    3: '油滴',
    4: '曜变',
  },
  classify: {
    1: '撇口',
    2: '敛口',
    3: '敞口',
    4: '束口',
    5: '将军杯',
    6: '创新器型',
  },
  articleClassify: {
    '1': '入门知识',
    '2': '工艺赏析',
    '3': '媒体资讯',
    '4': '文化历史',
    '5': '鉴选宝典',
    '6': '其他',
  },
  queryResult: [],
  token: Cookies.get('accessToken'),
  nickName: Cookies.get('nickName'),
  Img:  Cookies.get('Img'),
}



export default new Vuex.Store({
  state,
  action,
  getters: {
    getToken: state => state.token,
    getNickName: state => state.nickName == undefined ? "未登录" : state.nickName,
    getImg: state => state.Img == undefined
      ? require("@/assets/images/head@2x.png")
      : state.Img
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NICKNAME: (state, nickName) => {
      state.nickName = nickName
    },
    SET_IMG: (state, Img) => {
      state.Img = Img
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js